import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { CrudOperations } from 'src/app/shared/interfaces/crud-operations.interface';
import { ProdutoCategoriaModel, ProdutoFamiliaModel, ProdutoFamiliaRequest } from 'src/app/shared/models/produto-familia.model';
import { AdicionalFamiliaRequest, AdicionalProdutoRequest, AdicionalProdutoResponse, FamiliaResponse, GrupoIntegracaoRequest, GrupoIntegracaoResponse, GrupoIntegracaoStatusRequest, IngredienteLoteProdutoComposicaoRequest, IngredienteProdutoRequest, IngredienteProdutoResponse, PizzaLasanhaPrecoStatusRequest, ProdutoModel, ProdutoPizzaLasanhaQtdSabores, ProdutoRequest, ProdutoResponse, ProdutosIntegracaoResponse, ProdutosParaVendaRequest, Tamanho } from 'src/app/shared/models/produto.model';
import { AuthenticationService } from './authentication.service';
import { PerguntaFamiliaRequest, PerguntaProdutoRequest, PerguntaRequestBase, PerguntaRespose, RespostaFamiliaRequest, RespostaProdutoRequest, RespostaRequestBase } from 'src/app/shared/models/pergunta.model';
import { RequestDTO, ResultDTO } from 'src/app/shared/models/resultDTO.model';
import { PizzaLasanhaRequest } from 'src/app/shared/interfaces/pizza-lasanha.interface';

@Injectable({
    providedIn: 'root'
})
export class ProdutoService implements CrudOperations<ProdutoRequest> {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthenticationService
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/Produtos`;
    }

    getAll(): Observable<ApiResponse<ProdutoResponse[]>> {
        return this.httpClient.get<ApiResponse<ProdutoResponse[]>>(this.base + '/getAll').pipe(
            first()
        );
    }

    getAllComExcluidos(): Observable<ApiResponse<ProdutoResponse[]>> {
        return this.httpClient.get<ApiResponse<ProdutoResponse[]>>(this.base + '/getAll/true').pipe(
            first()
        );
    }

    create(model: ProdutoRequest): Observable<ApiResponse<ProdutoRequest>> {
        model.codBarra = model.codBarra ?? 0;
        
        return this.httpClient.post<ApiResponse<ProdutoRequest>>(this.base, model).pipe(
            first()
        );
    }

    AddOrUpdate(model: ProdutoRequest): Observable<ApiResponse<ProdutoRequest>> {
        if (model.codigo)
            return this.update(model.codigo, model);
        else
            return this.create(model);
            
    }

    delete(id: number): Observable<ApiResponse<any>> {
        return this.httpClient.delete<ApiResponse<any>>(this.base + '/' + id).pipe(
            first()
        );
    }

    get(): Observable<ApiResponse<ProdutoRequest[]>> {
        return this.httpClient.get<ApiResponse<ProdutoRequest[]>>(this.base).pipe(
            first()
        );
    }

    getAllByFamilia(familia: string) {
        return this.httpClient.get<ApiResponse<ProdutoRequest[]>>(`${this.base}/getAllByFamilia/${familia}`).pipe(
            first()
        );
    }

    getById(id: number): Observable<ApiResponse<ProdutoRequest>> {
        return this.httpClient.get<ApiResponse<ProdutoRequest>>(this.base + '/' + id).pipe(
            first()
        );
    }

    getFamiliasAutoAtendimento() {
        return this.httpClient.get<ApiResponse<ProdutoFamiliaModel[]>>(`${this.base}/familia/getFamiliasAutoAtendimento`).pipe(
            first()
        );
    }

    getProdutosDelivery() {
        return this.httpClient.get<ApiResponse<ProdutoModel[]>>(`${this.base}/produtosDelivery`).pipe(
            first()
        );
    }

    getProdutosFamilia() {
        return this.httpClient.get<ApiResponse<ProdutoFamiliaModel[]>>(`${this.base}/familia`).pipe(
            first()
        );
    }

    adicionarProdutoFamilia(grupo: ProdutoFamiliaRequest) {
        return this.httpClient.post<ApiResponse<ProdutoFamiliaModel>>(this.base + '/familia', grupo);
    }

    deletarProdutoFamilia(codigo: number) {
        return this.httpClient.delete<ApiResponse<boolean>>(this.base + '/familia/' + codigo);
    }

    getSubGrupos() {
        return this.httpClient.get<ApiResponse<ProdutoCategoriaModel[]>>(`${this.base}/categoria`).pipe(
            first()
        );
    }

    getSubGruposPorCodigoFamilia(codigoFamilia: number) {
        return this.httpClient.get<ApiResponse<ProdutoCategoriaModel[]>>(`${this.base}/categoria/GetAllByCodigoFamilia?codigoFamilia=${codigoFamilia}`).pipe(
            first()
        );
    }

    adicionarSubGrupo(grupo: ProdutoFamiliaRequest) {
        return this.httpClient.post<ApiResponse<ProdutoFamiliaModel>>(this.base + '/Categoria', grupo);
    }

    deletarSubGrupo(codigo: number) {
        return this.httpClient.delete<ApiResponse<boolean>>(this.base + '/Categoria/' + codigo);
    }

    update(id: number, model: ProdutoRequest): Observable<ApiResponse<ProdutoRequest>> {
        return this.httpClient.put<ApiResponse<ProdutoRequest>>(this.base + '/' + id, model, {}).pipe(
            first()
        );
    }

    getSaboresPizzaPrecosPorTamanho(): Observable<ApiResponse<string[]>> {
        return this.httpClient.get<ApiResponse<string[]>>(this.base + '/' + 'saboresPizzaPrecosPorTamanho').pipe(
            first()
        );
    }

    getSaboresLasanhaPrecoPorTamanho(): Observable<ApiResponse<string[]>> {
        return this.httpClient.get<ApiResponse<string[]>>(this.base + '/saboresLasanhaPrecosPorTamanho').pipe(
            first()
        );
    }

    getTamanhosPizza(): Observable<ApiResponse<Tamanho[]>> {
        return this.httpClient.get<ApiResponse<Tamanho[]>>(this.base + '/' + 'tamanhosPizza').pipe(
            first()
        );
    }

    getPizzaLasanha() {
        return this.httpClient.get<ApiResponse<ProdutoRequest[]>>(this.base + '/' + 'pizzaLasanha/GetAll').pipe(
            first()
        );
    }

    getTamanhosLasanha(): Observable<ApiResponse<Tamanho[]>> {
        return this.httpClient.get<ApiResponse<Tamanho[]>>(this.base + '/' + 'tamanhosLasanha').pipe(
            first()
        );
    }

    getProdutoPorCodigoBarra(codBarras: number): Observable<ApiResponse<ProdutoModel>> {
        return this.httpClient.get<ApiResponse<ProdutoModel>>(`${this.base}/codBarras/${codBarras}`);
    }

    getAllProdutosIntegracao(): Observable<ApiResponse<ProdutosIntegracaoResponse>> {
        const url = `${this.base}/integracao/GetAll/CadastroEmpresa`;
        return this.httpClient.get<ApiResponse<ProdutosIntegracaoResponse>>(url);
    }

    getAllGruposIntegracao(): Observable<ApiResponse<GrupoIntegracaoResponse[]>> {
        return this.httpClient.get<ApiResponse<GrupoIntegracaoResponse[]>>(this.base + '/integracao/grupo').pipe(
            first()
        );
    }

    updateGrupoIntegracao(model: GrupoIntegracaoRequest): Observable<ApiResponse<GrupoIntegracaoRequest>> {
        return this.httpClient.put<ApiResponse<GrupoIntegracaoRequest>>(this.base + '/integracao/grupo', model).pipe(
            first()
        );
    }

    alterarStatusGrupoIntegracao(model: GrupoIntegracaoStatusRequest): Observable<ApiResponse<GrupoIntegracaoStatusRequest>> {
        return this.httpClient.put<ApiResponse<GrupoIntegracaoStatusRequest>>(this.base + '/integracao/grupo/alterarStatus', model).pipe(
            first()
        );
    }

    // updateGrupoIntegracao(model: GrupoIntegracaoRequest): Observable<ApiResponse<GrupoIntegracaoRequest>> {
    //     const url = `${this.base}/integracao/grupo`;
    //     return this.httpClient.put<ApiResponse<GrupoIntegracaoRequest>>(url, model).pipe(
    //         first()
    //     );
    // }

    getAllProdutosIntregacaoMock(): Observable<any> {
        return this.httpClient.get<any>('http://localhost:3000/produtos');
    }

    updateProdutosIntegracao(request: ProdutosParaVendaRequest): Observable<ApiResponse<ProdutosParaVendaRequest>> {
        const url = `${this.base}/integracao`;
        return this.httpClient.put<ApiResponse<ProdutosParaVendaRequest>>(url, request);
    }

    updatePizzaLasanhaPreco(request: PizzaLasanhaPrecoStatusRequest[]): Observable<ApiResponse<PizzaLasanhaPrecoStatusRequest[]>> {
        const url = `${this.base}/atualizarValorPizzaLasanhaLoja`;
        return this.httpClient.put<ApiResponse<PizzaLasanhaPrecoStatusRequest[]>>(url, request);
    }

    excluirPizzaLasanha(model: PizzaLasanhaPrecoStatusRequest): Observable<ApiResponse<boolean>> {
        const url = `${this.base}/produto/excluirPizzaLasanhaLoja`;
        return this.httpClient.put<ApiResponse<boolean>>(url, model).pipe(
            first()
        );
    }

    ativarDesativarProduto(model: ProdutoResponse): Observable<ApiResponse<boolean>> {
        return this.httpClient.put<ApiResponse<boolean>>(this.base + `/ativarDesativarProduto/${model.codigo}/${model.ativo}`, {}).pipe(
            first()
        );
    }

    getGrupoIntegracao(): Observable<ApiResponse<GrupoIntegracaoRequest>> {
        const url = `${this.base}/integracao/grupo`;
        return this.httpClient.get<ApiResponse<GrupoIntegracaoRequest>>(url).pipe(
            first()
        );
    }

    getIngredientes(): Observable<ApiResponse<IngredienteProdutoResponse[]>> {
        return this.httpClient.get<ApiResponse<IngredienteProdutoResponse[]>>(`${this.base}/composicao/obterIngredientes`).pipe(
            first()
        );
    }

    getAdicionais(): Observable<ApiResponse<AdicionalProdutoResponse[]>> {
        return this.httpClient.get<ApiResponse<AdicionalProdutoResponse[]>>(`${this.base}/composicao/obterAdicionais`).pipe(
            first()
        );
    }

    incluirIngrediente(model: IngredienteProdutoRequest): Observable<ApiResponse<IngredienteProdutoRequest>> {
        return this.httpClient.post<ApiResponse<IngredienteProdutoRequest>>(`${this.base}/composicao/incluirIngrediente`, model).pipe(
            first()
        );
    }

    incluirIngredienteLote(model: IngredienteLoteProdutoComposicaoRequest): Observable<ApiResponse<any>> {
        return this.httpClient.post<ApiResponse<any>>(`${this.base}/composicao/incluirIngredienteLote`, model).pipe(
            first()
        );
    }

    obterIngredientesLote(codigosProdutos: number[]): Observable<ApiResponse<IngredienteProdutoResponse[]>> {
        return this.httpClient.post<ApiResponse<IngredienteProdutoResponse[]>>(`${this.base}/composicao/obterIngredientesLote`, codigosProdutos).pipe(
            first()
        );
    }

    incluirAdicional(model: AdicionalProdutoRequest): Observable<ApiResponse<AdicionalProdutoRequest>> {
        return this.httpClient.post<ApiResponse<AdicionalProdutoRequest>>(`${this.base}/composicao/incluirAdicional`, model).pipe(
            first()
        )
    }

    incluirAdicionalFamilia(model: AdicionalFamiliaRequest): Observable<ApiResponse<AdicionalFamiliaRequest>> {
        return this.httpClient.post<ApiResponse<AdicionalFamiliaRequest>>(`${this.base}/composicaofamilia/incluirAdicionalFamilia`, model).pipe(
            first()
        )
    }

    removerIngredineteProduto(model: IngredienteProdutoRequest) {
        return this.httpClient.delete<ApiResponse<IngredienteProdutoRequest>>(`${this.base}/composicao/deletarIngrediente/${model.nome}/${model.codigoProduto}`).pipe(
            first()
        );
    }

    deletarIngredienteLote(request: IngredienteLoteProdutoComposicaoRequest): Observable<ApiResponse<any>> {
        return this.httpClient.post<ApiResponse<any>>(`${this.base}/composicao/deletarIngredienteLote`, request).pipe(
            first()
        );
    }

    removerAdicionalProduto(model: AdicionalProdutoRequest) {
        return this.httpClient.delete<ApiResponse<AdicionalProdutoRequest>>(`${this.base}/composicao/deletarAdicional/${model.nome}/${model.codigoProduto}`).pipe(
            first()
        )
    }

    removerAdicionalFamilia(model: AdicionalFamiliaRequest) {
        return this.httpClient.delete<ApiResponse<AdicionalFamiliaRequest>>(`${this.base}/composicaoFamilia/deletarAdicionalFamilia/${model.nome}/${model.codigoFamilia}`).pipe(
            first()
        )
    }

    getAdicionaisPorFamilia(codigoFamilia: number): Observable<ApiResponse<AdicionalProdutoResponse[]>> {
        return this.httpClient.get<ApiResponse<AdicionalProdutoResponse[]>>(`${this.base}/composicaoFamilia/obterAdicionaisFamilia/${codigoFamilia}`).pipe(
            first()
        );
    }

    getAllPerguntas(): Observable<ApiResponse<PerguntaRespose[]>> {
        return this.httpClient.get<ApiResponse<PerguntaRespose[]>>(`${this.base}/perguntas/GetAll`).pipe(
            first()
        );
    }

    getPerguntasPorCodigoProduto(codigoProduto: number): Observable<ApiResponse<PerguntaRespose[]>> {
        return this.httpClient.get<ApiResponse<PerguntaRespose[]>>(`${this.base}/perguntas/GetPorCodigoProduto/${codigoProduto}`).pipe(
            first()
        );
    }

    createPergunta(pergunta: PerguntaProdutoRequest): Observable<ApiResponse<PerguntaRequestBase>> {
        return this.httpClient.post<ApiResponse<PerguntaRequestBase>>(`${this.base}/perguntas/IncluirPergunta`, pergunta).pipe(
            first()
        );
    }

    createProdutoResposta(resposta: RespostaProdutoRequest): Observable<ApiResponse<number>> {
        return this.httpClient.post<ApiResponse<number>>(`${this.base}/respostas/IncluirResposta`, resposta).pipe(
            first()
        );
    }

    alterarProdutoPergunta(pergunta: PerguntaProdutoRequest): Observable<ApiResponse<PerguntaRequestBase>> {
        return this.httpClient.put<ApiResponse<PerguntaRequestBase>>(`${this.base}/perguntas/AlterarPergunta`, pergunta).pipe(
            first()
        );
    }

    alterarProdutoResposta(resposta: RespostaProdutoRequest): Observable<ApiResponse<RespostaFamiliaRequest>> {
        return this.httpClient.put<ApiResponse<RespostaFamiliaRequest>>(`${this.base}/respostas/AlterarResposta`, resposta).pipe(
            first()
        )
    }

    removerProdutoPergunta(codigoPergunta: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.base}/perguntas/ExcluirPergunta/${codigoPergunta}`).pipe(
            first()
        );
    }

    removerProdutoResposta(codigoResposta: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.base}/respostas/ExcluirResposta/${codigoResposta}`).pipe(
            first()
        );
    }

    getPerguntasPorCodigoFamilia(codigoFamilia: number): Observable<ApiResponse<PerguntaRespose[]>> {
        return this.httpClient.get<ApiResponse<PerguntaRespose[]>>(`${this.base}/perguntasfamilia/GetPorCodigoFamilia/${codigoFamilia}`).pipe(
            first()
        );
    }

    createPerguntaFamilia(pergunta: PerguntaFamiliaRequest): Observable<ApiResponse<PerguntaRequestBase>> {
        return this.httpClient.post<ApiResponse<PerguntaRequestBase>>(`${this.base}/perguntasfamilia/IncluirPergunta`, pergunta).pipe(
            first()
        );
    }

    createFamiliaResposta(resposta: RespostaFamiliaRequest): Observable<ApiResponse<null>> {
        return this.httpClient.post<ApiResponse<null>>(`${this.base}/respostasfamilia/IncluirResposta`, resposta).pipe(
            first()
        );
    }

    alterarFamiliaPergunta(pergunta: PerguntaFamiliaRequest): Observable<ApiResponse<PerguntaRequestBase>> {
        return this.httpClient.put<ApiResponse<PerguntaRequestBase>>(`${this.base}/perguntasfamilia/AlterarPergunta`, pergunta).pipe(
            first()
        );
    }

    alterarFamiliaResposta(resposta: RespostaFamiliaRequest): Observable<ApiResponse<RespostaRequestBase>> {
        return this.httpClient.put<ApiResponse<RespostaRequestBase>>(`${this.base}/respostasfamilia/AlterarResposta`, resposta).pipe(
            first()
        )
    }

    removerFamiliaPergunta(codigoPergunta: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.base}/perguntasfamilia/ExcluirPergunta/${codigoPergunta}`).pipe(
            first()
        );
    }

    removerFamiliaResposta(codigoResposta: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.base}/respostasfamilia/ExcluirResposta/${codigoResposta}`).pipe(
            first()
        );
    }

    getAllProdutosPizzaLasanhaQtdSabores(): Observable<ApiResponse<ProdutoPizzaLasanhaQtdSabores[]>> {
        return this.httpClient.get<ApiResponse<ProdutoPizzaLasanhaQtdSabores[]>>(`${this.base}/qtdSabores`).pipe(
            first()
        );
    }

    alterarProdutosPizzaLasanhaQtdSabores(model: ProdutoPizzaLasanhaQtdSabores): Observable<ApiResponse<ProdutoPizzaLasanhaQtdSabores>> {
        return this.httpClient.put<ApiResponse<ProdutoPizzaLasanhaQtdSabores>>(`${this.base}/qtdSabores`, model).pipe(
            first()
        );
    }

    adicionarSaborPizza(pizza: PizzaLasanhaRequest) {
        return this.httpClient.post<ApiResponse<PizzaLasanhaRequest>>(`${this.base}/pizza`, pizza);
    }

    adicionarSaborLasanha(pizza: PizzaLasanhaRequest) {
        return this.httpClient.post<ApiResponse<PizzaLasanhaRequest>>(`${this.base}/lasanha`, pizza);
    }
}